/**
 * Carbon — paid traffic detection (Meta / social ads).
 * Liquid request.params is unreliable in some preview contexts.
 */
(function () {
  const params = new URLSearchParams(window.location.search);
  const source = (params.get("utm_source") || "").toLowerCase();
  const medium = (params.get("utm_medium") || "").toLowerCase();

  const isPaid =
    params.has("fbclid") ||
    ["facebook", "fb", "instagram", "meta", "ig"].includes(source) ||
    ["paid", "cpc", "social"].includes(medium);

  if (!isPaid) return;

  document.documentElement.classList.add("carbon-paid-traffic");
  document.body.classList.add("carbon-paid-traffic");
})();
